// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file calendar/event_request.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { Platform } from '../common/common_model_pb';
import { file_common_common_model } from '../common/common_model_pb';
import type {
  CalendarAccount,
  CalendarType,
  ConfirmationType,
  ReminderType,
  SubscribeToCalendarPush,
} from './event_model_pb';
import { file_calendar_event_model } from './event_model_pb';

/**
 * Describes the file calendar/event_request.proto.
 */
export const file_calendar_event_request: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChxjYWxlbmRhci9ldmVudF9yZXF1ZXN0LnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCJRCg9SZXF1ZXN0UmVtaW5kZXISMAoEdHlwZRgBIAEoDjIiLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlJlbWluZGVyVHlwZRIMCgR0aW1lGAIgASgDItoDChpDcmVhdGVDYWxlbmRhckV2ZW50UmVxdWVzdBINCgV0aXRsZRgBIAEoCRITCgtzdGFydFRpbWVUcxgCIAEoAxIRCgllbmRUaW1lVHMYAyABKAMSDgoGYWxsRGF5GAQgASgIEhUKCHRpbWVab25lGAUgASgJSACIAQESFQoIbG9jYXRpb24YBiABKAlIAYgBARIYCgtkZXNjcmlwdGlvbhgHIAEoCUgCiAEBEhsKDnJlY3VycmVuY2VUeXBlGAggASgJSAOIAQESFQoIY2hhdExpbmsYCSABKAlIBIgBARIVCghjYWxsTGluaxgKIAEoCUgFiAEBEjgKCXJlbWluZGVycxgLIAMoCzIlLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlJlcXVlc3RSZW1pbmRlchIZChFwYXJ0aWNpcGFudEVtYWlscxgMIAMoCRI2CgdhY2NvdW50GA0gASgLMiUuY29tLmdlbS5iZmYuY29udHJhY3QuQ2FsZW5kYXJBY2NvdW50QgsKCV90aW1lWm9uZUILCglfbG9jYXRpb25CDgoMX2Rlc2NyaXB0aW9uQhEKD19yZWN1cnJlbmNlVHlwZUILCglfY2hhdExpbmtCCwoJX2NhbGxMaW5rImoKF0dldENhbGVuZGFyRXZlbnRSZXF1ZXN0EhcKD3Byb3ZpZGVyRXZlbnRJZBgBIAEoCRI2CgdhY2NvdW50GAIgASgLMiUuY29tLmdlbS5iZmYuY29udHJhY3QuQ2FsZW5kYXJBY2NvdW50IjQKGEdldENhbGVuZGFyRXZlbnRzUmVxdWVzdBIMCgRmcm9tGAEgASgDEgoKAnRvGAIgASgDIsMDChpVcGRhdGVDYWxlbmRhckV2ZW50UmVxdWVzdBIXCg9wcm92aWRlckV2ZW50SWQYASABKAkSDQoFdGl0bGUYAiABKAkSEwoLc3RhcnRUaW1lVHMYAyABKAMSEQoJZW5kVGltZVRzGAQgASgDEg4KBmFsbERheRgFIAEoCBIVCgh0aW1lWm9uZRgGIAEoCUgAiAEBEhUKCGxvY2F0aW9uGAcgASgJSAGIAQESGAoLZGVzY3JpcHRpb24YCCABKAlIAogBARIVCghjaGF0TGluaxgKIAEoCUgDiAEBEhUKCGNhbGxMaW5rGAsgASgJSASIAQESOAoJcmVtaW5kZXJzGAwgAygLMiUuY29tLmdlbS5iZmYuY29udHJhY3QuUmVxdWVzdFJlbWluZGVyEhkKEXBhcnRpY2lwYW50RW1haWxzGA0gAygJEjYKB2FjY291bnQYDiABKAsyJS5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxlbmRhckFjY291bnRCCwoJX3RpbWVab25lQgsKCV9sb2NhdGlvbkIOCgxfZGVzY3JpcHRpb25CCwoJX2NoYXRMaW5rQgsKCV9jYWxsTGluayJtChpEZWxldGVDYWxlbmRhckV2ZW50UmVxdWVzdBIXCg9wcm92aWRlckV2ZW50SWQYASABKAkSNgoHYWNjb3VudBgCIAEoCzIlLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNhbGVuZGFyQWNjb3VudCJoChxEZWxldGVSZWN1cnJlbmNlRXZlbnRSZXF1ZXN0EhAKCHBhcmVudElkGAEgASgJEjYKB2FjY291bnQYAiABKAsyJS5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxlbmRhckFjY291bnQilQEKHlN1YnNjcmliZVRvQ2FsZW5kYXJQdXNoUmVxdWVzdBJBCgpzdWJzY3JpYmVzGAEgAygLMi0uY29tLmdlbS5iZmYuY29udHJhY3QuU3Vic2NyaWJlVG9DYWxlbmRhclB1c2gSMAoIcGxhdGZvcm0YAiABKA4yHi5jb20uZ2VtLmJmZi5jb250cmFjdC5QbGF0Zm9ybSL2AwokVXBkYXRlUmVjdXJyZW5jZUNhbGVuZGFyRXZlbnRSZXF1ZXN0EhAKCHBhcmVudElkGAEgASgJEg0KBXRpdGxlGAIgASgJEhMKC3N0YXJ0VGltZVRzGAMgASgDEhEKCWVuZFRpbWVUcxgEIAEoAxIOCgZhbGxEYXkYBSABKAgSFQoIdGltZVpvbmUYBiABKAlIAIgBARIVCghsb2NhdGlvbhgHIAEoCUgBiAEBEhgKC2Rlc2NyaXB0aW9uGAggASgJSAKIAQESGwoOcmVjdXJyZW5jZVR5cGUYCSABKAlIA4gBARIVCghjaGF0TGluaxgKIAEoCUgEiAEBEhUKCGNhbGxMaW5rGAsgASgJSAWIAQESOAoJcmVtaW5kZXJzGAwgAygLMiUuY29tLmdlbS5iZmYuY29udHJhY3QuUmVxdWVzdFJlbWluZGVyEhkKEXBhcnRpY2lwYW50RW1haWxzGA0gAygJEjYKB2FjY291bnQYDiABKAsyJS5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxlbmRhckFjY291bnRCCwoJX3RpbWVab25lQgsKCV9sb2NhdGlvbkIOCgxfZGVzY3JpcHRpb25CEQoPX3JlY3VycmVuY2VUeXBlQgsKCV9jaGF0TGlua0ILCglfY2FsbExpbmsiQgodU2F2ZUNhbGVuZGFyQ3JlZGVudGlhbFJlcXVlc3QSDAoEY29kZRgBIAEoCRITCgtyZWRpcmVjdFVyaRgCIAEoCSJPChVMb2dvdXRDYWxlbmRhclJlcXVlc3QSNgoHYWNjb3VudBgBIAEoCzIlLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNhbGVuZGFyQWNjb3VudCIbChlDaGVja0F1dGhvcml6YXRpb25SZXF1ZXN0IrgBCiNVcGRhdGVFdmVudFBhcnRpY2lwYW50U3RhdHVzUmVxdWVzdBIXCg9wcm92aWRlckV2ZW50SWQYASABKAkSQAoQY29uZmlybWF0aW9uVHlwZRgCIAEoDjImLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNvbmZpcm1hdGlvblR5cGUSNgoHYWNjb3VudBgDIAEoCzIlLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNhbGVuZGFyQWNjb3VudCIYChZHZXRVc2VyU2V0dGluZ3NSZXF1ZXN0IikKFENoYW5nZUNvbXBhY3RSZXF1ZXN0EhEKCWlzQ29tcGFjdBgBIAEoCCKDAQokU2VhcmNoVXNlcnNBZGRUb0NhbGVuZGFyRXZlbnRSZXF1ZXN0Eg0KBXF1ZXJ5GAEgASgJEhMKBmN1cnNvchgCIAEoCUgAiAEBEhIKBWxpbWl0GAMgASgFSAGIAQESDgoGZW1haWxzGAQgAygJQgkKB19jdXJzb3JCCAoGX2xpbWl0IloKIFVuc3Vic2NyaWJlVG9DYWxlbmRhclB1c2hSZXF1ZXN0EjYKB2FjY291bnQYASADKAsyJS5jb20uZ2VtLmJmZi5jb250cmFjdC5DYWxlbmRhckFjY291bnQilAEKGUdldENhbGVuZGFyQXV0aFVybFJlcXVlc3QSMAoEdHlwZRgBIAEoDjIiLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNhbGVuZGFyVHlwZRIwCghwbGF0Zm9ybRgCIAEoDjIeLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlBsYXRmb3JtEhMKC3JlZGlyZWN0VXJpGAMgASgJQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw',
    [file_calendar_event_model, file_common_common_model]
  );

/**
 * @generated from message com.gem.bff.contract.RequestReminder
 */
export type RequestReminder = Message<'com.gem.bff.contract.RequestReminder'> & {
  /**
   * @generated from field: com.gem.bff.contract.ReminderType type = 1;
   */
  type: ReminderType;

  /**
   * @generated from field: int64 time = 2;
   */
  time: bigint;
};

/**
 * Describes the message com.gem.bff.contract.RequestReminder.
 * Use `create(RequestReminderSchema)` to create a new message.
 */
export const RequestReminderSchema: GenMessage<RequestReminder> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 0);

/**
 * @generated from message com.gem.bff.contract.CreateCalendarEventRequest
 */
export type CreateCalendarEventRequest =
  Message<'com.gem.bff.contract.CreateCalendarEventRequest'> & {
    /**
     * @generated from field: string title = 1;
     */
    title: string;

    /**
     * @generated from field: int64 startTimeTs = 2;
     */
    startTimeTs: bigint;

    /**
     * @generated from field: int64 endTimeTs = 3;
     */
    endTimeTs: bigint;

    /**
     * @generated from field: bool allDay = 4;
     */
    allDay: boolean;

    /**
     * @generated from field: optional string timeZone = 5;
     */
    timeZone?: string;

    /**
     * @generated from field: optional string location = 6;
     */
    location?: string;

    /**
     * @generated from field: optional string description = 7;
     */
    description?: string;

    /**
     * @generated from field: optional string recurrenceType = 8;
     */
    recurrenceType?: string;

    /**
     * @generated from field: optional string chatLink = 9;
     */
    chatLink?: string;

    /**
     * @generated from field: optional string callLink = 10;
     */
    callLink?: string;

    /**
     * @generated from field: repeated com.gem.bff.contract.RequestReminder reminders = 11;
     */
    reminders: RequestReminder[];

    /**
     * @generated from field: repeated string participantEmails = 12;
     */
    participantEmails: string[];

    /**
     * @generated from field: com.gem.bff.contract.CalendarAccount account = 13;
     */
    account?: CalendarAccount;
  };

/**
 * Describes the message com.gem.bff.contract.CreateCalendarEventRequest.
 * Use `create(CreateCalendarEventRequestSchema)` to create a new message.
 */
export const CreateCalendarEventRequestSchema: GenMessage<CreateCalendarEventRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 1);

/**
 * @generated from message com.gem.bff.contract.GetCalendarEventRequest
 */
export type GetCalendarEventRequest = Message<'com.gem.bff.contract.GetCalendarEventRequest'> & {
  /**
   * @generated from field: string providerEventId = 1;
   */
  providerEventId: string;

  /**
   * @generated from field: com.gem.bff.contract.CalendarAccount account = 2;
   */
  account?: CalendarAccount;
};

/**
 * Describes the message com.gem.bff.contract.GetCalendarEventRequest.
 * Use `create(GetCalendarEventRequestSchema)` to create a new message.
 */
export const GetCalendarEventRequestSchema: GenMessage<GetCalendarEventRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 2);

/**
 * @generated from message com.gem.bff.contract.GetCalendarEventsRequest
 */
export type GetCalendarEventsRequest = Message<'com.gem.bff.contract.GetCalendarEventsRequest'> & {
  /**
   * @generated from field: int64 from = 1;
   */
  from: bigint;

  /**
   * @generated from field: int64 to = 2;
   */
  to: bigint;
};

/**
 * Describes the message com.gem.bff.contract.GetCalendarEventsRequest.
 * Use `create(GetCalendarEventsRequestSchema)` to create a new message.
 */
export const GetCalendarEventsRequestSchema: GenMessage<GetCalendarEventsRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 3);

/**
 * @generated from message com.gem.bff.contract.UpdateCalendarEventRequest
 */
export type UpdateCalendarEventRequest =
  Message<'com.gem.bff.contract.UpdateCalendarEventRequest'> & {
    /**
     * @generated from field: string providerEventId = 1;
     */
    providerEventId: string;

    /**
     * @generated from field: string title = 2;
     */
    title: string;

    /**
     * @generated from field: int64 startTimeTs = 3;
     */
    startTimeTs: bigint;

    /**
     * @generated from field: int64 endTimeTs = 4;
     */
    endTimeTs: bigint;

    /**
     * @generated from field: bool allDay = 5;
     */
    allDay: boolean;

    /**
     * @generated from field: optional string timeZone = 6;
     */
    timeZone?: string;

    /**
     * @generated from field: optional string location = 7;
     */
    location?: string;

    /**
     * @generated from field: optional string description = 8;
     */
    description?: string;

    /**
     * @generated from field: optional string chatLink = 10;
     */
    chatLink?: string;

    /**
     * @generated from field: optional string callLink = 11;
     */
    callLink?: string;

    /**
     * @generated from field: repeated com.gem.bff.contract.RequestReminder reminders = 12;
     */
    reminders: RequestReminder[];

    /**
     * @generated from field: repeated string participantEmails = 13;
     */
    participantEmails: string[];

    /**
     * @generated from field: com.gem.bff.contract.CalendarAccount account = 14;
     */
    account?: CalendarAccount;
  };

/**
 * Describes the message com.gem.bff.contract.UpdateCalendarEventRequest.
 * Use `create(UpdateCalendarEventRequestSchema)` to create a new message.
 */
export const UpdateCalendarEventRequestSchema: GenMessage<UpdateCalendarEventRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 4);

/**
 * @generated from message com.gem.bff.contract.DeleteCalendarEventRequest
 */
export type DeleteCalendarEventRequest =
  Message<'com.gem.bff.contract.DeleteCalendarEventRequest'> & {
    /**
     * @generated from field: string providerEventId = 1;
     */
    providerEventId: string;

    /**
     * @generated from field: com.gem.bff.contract.CalendarAccount account = 2;
     */
    account?: CalendarAccount;
  };

/**
 * Describes the message com.gem.bff.contract.DeleteCalendarEventRequest.
 * Use `create(DeleteCalendarEventRequestSchema)` to create a new message.
 */
export const DeleteCalendarEventRequestSchema: GenMessage<DeleteCalendarEventRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 5);

/**
 * @generated from message com.gem.bff.contract.DeleteRecurrenceEventRequest
 */
export type DeleteRecurrenceEventRequest =
  Message<'com.gem.bff.contract.DeleteRecurrenceEventRequest'> & {
    /**
     * @generated from field: string parentId = 1;
     */
    parentId: string;

    /**
     * @generated from field: com.gem.bff.contract.CalendarAccount account = 2;
     */
    account?: CalendarAccount;
  };

/**
 * Describes the message com.gem.bff.contract.DeleteRecurrenceEventRequest.
 * Use `create(DeleteRecurrenceEventRequestSchema)` to create a new message.
 */
export const DeleteRecurrenceEventRequestSchema: GenMessage<DeleteRecurrenceEventRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 6);

/**
 * @generated from message com.gem.bff.contract.SubscribeToCalendarPushRequest
 */
export type SubscribeToCalendarPushRequest =
  Message<'com.gem.bff.contract.SubscribeToCalendarPushRequest'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.SubscribeToCalendarPush subscribes = 1;
     */
    subscribes: SubscribeToCalendarPush[];

    /**
     * @generated from field: com.gem.bff.contract.Platform platform = 2;
     */
    platform: Platform;
  };

/**
 * Describes the message com.gem.bff.contract.SubscribeToCalendarPushRequest.
 * Use `create(SubscribeToCalendarPushRequestSchema)` to create a new message.
 */
export const SubscribeToCalendarPushRequestSchema: GenMessage<SubscribeToCalendarPushRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 7);

/**
 * @generated from message com.gem.bff.contract.UpdateRecurrenceCalendarEventRequest
 */
export type UpdateRecurrenceCalendarEventRequest =
  Message<'com.gem.bff.contract.UpdateRecurrenceCalendarEventRequest'> & {
    /**
     * @generated from field: string parentId = 1;
     */
    parentId: string;

    /**
     * @generated from field: string title = 2;
     */
    title: string;

    /**
     * @generated from field: int64 startTimeTs = 3;
     */
    startTimeTs: bigint;

    /**
     * @generated from field: int64 endTimeTs = 4;
     */
    endTimeTs: bigint;

    /**
     * @generated from field: bool allDay = 5;
     */
    allDay: boolean;

    /**
     * @generated from field: optional string timeZone = 6;
     */
    timeZone?: string;

    /**
     * @generated from field: optional string location = 7;
     */
    location?: string;

    /**
     * @generated from field: optional string description = 8;
     */
    description?: string;

    /**
     * @generated from field: optional string recurrenceType = 9;
     */
    recurrenceType?: string;

    /**
     * @generated from field: optional string chatLink = 10;
     */
    chatLink?: string;

    /**
     * @generated from field: optional string callLink = 11;
     */
    callLink?: string;

    /**
     * @generated from field: repeated com.gem.bff.contract.RequestReminder reminders = 12;
     */
    reminders: RequestReminder[];

    /**
     * @generated from field: repeated string participantEmails = 13;
     */
    participantEmails: string[];

    /**
     * @generated from field: com.gem.bff.contract.CalendarAccount account = 14;
     */
    account?: CalendarAccount;
  };

/**
 * Describes the message com.gem.bff.contract.UpdateRecurrenceCalendarEventRequest.
 * Use `create(UpdateRecurrenceCalendarEventRequestSchema)` to create a new message.
 */
export const UpdateRecurrenceCalendarEventRequestSchema: GenMessage<UpdateRecurrenceCalendarEventRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 8);

/**
 * @generated from message com.gem.bff.contract.SaveCalendarCredentialRequest
 */
export type SaveCalendarCredentialRequest =
  Message<'com.gem.bff.contract.SaveCalendarCredentialRequest'> & {
    /**
     * @generated from field: string code = 1;
     */
    code: string;

    /**
     * @generated from field: string redirectUri = 2;
     */
    redirectUri: string;
  };

/**
 * Describes the message com.gem.bff.contract.SaveCalendarCredentialRequest.
 * Use `create(SaveCalendarCredentialRequestSchema)` to create a new message.
 */
export const SaveCalendarCredentialRequestSchema: GenMessage<SaveCalendarCredentialRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 9);

/**
 * @generated from message com.gem.bff.contract.LogoutCalendarRequest
 */
export type LogoutCalendarRequest = Message<'com.gem.bff.contract.LogoutCalendarRequest'> & {
  /**
   * @generated from field: com.gem.bff.contract.CalendarAccount account = 1;
   */
  account?: CalendarAccount;
};

/**
 * Describes the message com.gem.bff.contract.LogoutCalendarRequest.
 * Use `create(LogoutCalendarRequestSchema)` to create a new message.
 */
export const LogoutCalendarRequestSchema: GenMessage<LogoutCalendarRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 10);

/**
 * @generated from message com.gem.bff.contract.CheckAuthorizationRequest
 */
export type CheckAuthorizationRequest =
  Message<'com.gem.bff.contract.CheckAuthorizationRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.CheckAuthorizationRequest.
 * Use `create(CheckAuthorizationRequestSchema)` to create a new message.
 */
export const CheckAuthorizationRequestSchema: GenMessage<CheckAuthorizationRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 11);

/**
 * @generated from message com.gem.bff.contract.UpdateEventParticipantStatusRequest
 */
export type UpdateEventParticipantStatusRequest =
  Message<'com.gem.bff.contract.UpdateEventParticipantStatusRequest'> & {
    /**
     * @generated from field: string providerEventId = 1;
     */
    providerEventId: string;

    /**
     * @generated from field: com.gem.bff.contract.ConfirmationType confirmationType = 2;
     */
    confirmationType: ConfirmationType;

    /**
     * @generated from field: com.gem.bff.contract.CalendarAccount account = 3;
     */
    account?: CalendarAccount;
  };

/**
 * Describes the message com.gem.bff.contract.UpdateEventParticipantStatusRequest.
 * Use `create(UpdateEventParticipantStatusRequestSchema)` to create a new message.
 */
export const UpdateEventParticipantStatusRequestSchema: GenMessage<UpdateEventParticipantStatusRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 12);

/**
 * @generated from message com.gem.bff.contract.GetUserSettingsRequest
 */
export type GetUserSettingsRequest = Message<'com.gem.bff.contract.GetUserSettingsRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetUserSettingsRequest.
 * Use `create(GetUserSettingsRequestSchema)` to create a new message.
 */
export const GetUserSettingsRequestSchema: GenMessage<GetUserSettingsRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 13);

/**
 * @generated from message com.gem.bff.contract.ChangeCompactRequest
 */
export type ChangeCompactRequest = Message<'com.gem.bff.contract.ChangeCompactRequest'> & {
  /**
   * @generated from field: bool isCompact = 1;
   */
  isCompact: boolean;
};

/**
 * Describes the message com.gem.bff.contract.ChangeCompactRequest.
 * Use `create(ChangeCompactRequestSchema)` to create a new message.
 */
export const ChangeCompactRequestSchema: GenMessage<ChangeCompactRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 14);

/**
 * @generated from message com.gem.bff.contract.SearchUsersAddToCalendarEventRequest
 */
export type SearchUsersAddToCalendarEventRequest =
  Message<'com.gem.bff.contract.SearchUsersAddToCalendarEventRequest'> & {
    /**
     * @generated from field: string query = 1;
     */
    query: string;

    /**
     * @generated from field: optional string cursor = 2;
     */
    cursor?: string;

    /**
     * @generated from field: optional int32 limit = 3;
     */
    limit?: number;

    /**
     * @generated from field: repeated string emails = 4;
     */
    emails: string[];
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersAddToCalendarEventRequest.
 * Use `create(SearchUsersAddToCalendarEventRequestSchema)` to create a new message.
 */
export const SearchUsersAddToCalendarEventRequestSchema: GenMessage<SearchUsersAddToCalendarEventRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 15);

/**
 * @generated from message com.gem.bff.contract.UnsubscribeToCalendarPushRequest
 */
export type UnsubscribeToCalendarPushRequest =
  Message<'com.gem.bff.contract.UnsubscribeToCalendarPushRequest'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.CalendarAccount account = 1;
     */
    account: CalendarAccount[];
  };

/**
 * Describes the message com.gem.bff.contract.UnsubscribeToCalendarPushRequest.
 * Use `create(UnsubscribeToCalendarPushRequestSchema)` to create a new message.
 */
export const UnsubscribeToCalendarPushRequestSchema: GenMessage<UnsubscribeToCalendarPushRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 16);

/**
 * @generated from message com.gem.bff.contract.GetCalendarAuthUrlRequest
 */
export type GetCalendarAuthUrlRequest =
  Message<'com.gem.bff.contract.GetCalendarAuthUrlRequest'> & {
    /**
     * @generated from field: com.gem.bff.contract.CalendarType type = 1;
     */
    type: CalendarType;

    /**
     * @generated from field: com.gem.bff.contract.Platform platform = 2;
     */
    platform: Platform;

    /**
     * @generated from field: string redirectUri = 3;
     */
    redirectUri: string;
  };

/**
 * Describes the message com.gem.bff.contract.GetCalendarAuthUrlRequest.
 * Use `create(GetCalendarAuthUrlRequestSchema)` to create a new message.
 */
export const GetCalendarAuthUrlRequestSchema: GenMessage<GetCalendarAuthUrlRequest> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_request, 17);
